The phone number represented as a human readable string.
